import { gql } from "@apollo/client";

export const GET_PARTICIPANTS = gql`
	query GetParticipants($contestname: String!, $userid: ID!) {
		getParticipants(contestname:$contestname, userid:$userid) {
			userid
			name
			alias
			university
			weekly_return
	  		weekly_maxdrawdown
			pltrend
		}
	}
`

export const GET_CONTESTS_BY_NAME = gql`
	query GetContestByName($contestname: String!) {
		getContestByName(contestname: $contestname) {
            id
            name
            startat
            endat
		}
	}
`

export const GET_ALL_CONTESTS = gql`
	query GetAllContests {
		getAllContests {
            id
            name
            startat
            endat
		}
	}
`


export const GET_LEADERBOARD = gql`
	query GetLeaderboard {
		getLeaderboard {
            userid
            name
            alias
            university
            total_return
            attended
		}
	}
`

export const IS_USER_IN_ONGOING_CONTEST = gql`
	query IsUserInOngoingContest($userid: ID!) {
		isUserInOngoingContest(userid: $userid)
	}
`

// userid is derived from the JWT context on the server — do not pass it as an
// argument (the merged backend no longer accepts it and rejects the query).
export const ADD_PARTICIPANT_TO_CONTEST = gql`
  mutation AddParticipantToContest($contestname: String!) {
    addParticipantToContest(contestname: $contestname) {
      userid
      name
	  alias
	  university
      weekly_return
	  weekly_maxdrawdown
      pltrend
    }
  }
`;

export const REMOVE_PARTICIPANT_FROM_CONTEST = gql`
  mutation RemoveParticipantFromContest($contestname: String!) {
    removeParticipantFromContest(contestname: $contestname)
  }
`;

export const UPDATE_WEEKLY_RETURN_OF_PARTICIPANT = gql`
  mutation UpdateWeeklyReturnOfParticipant($contestname: String!) {
    updateWeeklyReturnOfParticipant(contestname: $contestname)
  }
`;